/**
 * Created by yousefJbour on 8/13/18.
 */
(function (angular) {

    "use strict";
    angular
        .module('harriApp')
        .controller('HMAPAtrsManageController', [
            '$scope', '$stateParams', '$state', 'hmapService', 'hFormsService', '$filter', '$location',
            function ($scope, $stateParams, $state, hmapService, hFormsService, $filter, $location) {
                var activeBrandId = hmapService.getActiveBrand();

                var MbAtrEditForm = new hFormsService.getForm("MbAtrEditForm");

                var init = function () {
                    var atrBrandId = $stateParams['brand_id'];
                    var atrId = $stateParams['atr_id'];
                    $scope.atrId = atrId;

                    $scope.mbAtrEditForm = new MbAtrEditForm($scope, 'mb-atr-edit-form', activeBrandId);
                    $scope.mbAtrEditForm.load(atrBrandId, atrId);
                };

                $scope.saveDraft = function () {
                    $scope.mbAtrEditForm.saveAsDraft()
                        .then(function () {
                            $state.go("appLayout.harriSH.access-portal.atrs-listings", { hmapPath: $stateParams['hmapPath'] });
                            $scope.$apply();
                        })
                        .catch(function (err) {
                            if (err && err.error === 'VALIDATION') {
                                hAlert(
                                    $filter("translate")("Missing Data"),
                                    $filter("translate")("In order to save recruitment authority as draft, please make sure to select location, category and position.")
                                );
                            }
                            else {
                                hAlert(
                                    $filter("translate")("Error"),
                                    $filter("translate")("Something went wrong while saving recruitment authority")
                                );
                            }
                        })
                };

                $scope.save = function () {
                    $scope.mbAtrEditForm.validator.validate(function (isValid) {
                        if (isValid) {
                            $scope.mbAtrEditForm.save()
                                .then(function (res) {
                                    $state.go("appLayout.harriSH.access-portal.atrs-listings", { hmapPath: $stateParams['hmapPath'] });
                                    $scope.$apply();
                                })
                                .catch(function (err) {
                                    hAlert(
                                        $filter("translate")("Error"),
                                        $filter("translate")("Something went wrong while saving recruitment authority")
                                    );
                                });
                        }
                        else {
                            setTimeout(function () {
                                $("html,body").animate({
                                    scrollTop: $(".error:first").offset().top - 200
                                });
                            }, 300);
                        }
                    })
                };

                $scope.reSubmit = function(){
                    hConfirm({
                        title: $filter("translate")("Update recruitment authority"),
                        text: $filter("translate")("This will resubmit the recruitment authority to be approved again, Are you sure?"),
                        callback: function (confirmed) {
                            if (confirmed) {
                                $scope.save();
                            }
                        }
                    });
                }

                init();
            }]);

})(angular);
